import React, { useCallback, useState } from 'react';
import Checked from '../Check'
import CloseBtn from '../CloseBtn'

const Bads = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6+'
]
const source_img = [
  {
    imgurl: 'm2m.png',
    tag: 0
  },
  {
    imgurl: 'airbnb.png',
    tag: 2
  },
  {
    imgurl: 'vrbo.png',
    tag: 3
  },
  {
    imgurl: 'Zillow.png',
    tag: 1
  },
]

type Iprops = {
  onSubmit?: (beds:string, source: string) => void
}
function Fileter(props: Iprops) {
  const {
    onSubmit,
  } = props
  let [show, setShow] = useState(false)
  let [beds, setBeds] = useState<Set<number>>(new Set([0,1,2,3,4,5]))
  let [source, setsource] = useState<Set<number>>(new Set([0,1,2,3]))

  const submit = useCallback(() => {
    let bStr = '',
    sStr = '';
    beds.forEach(item => {
      bStr += `${item + 1}`
    })
    source.forEach(item => {
      sStr += item
    })
    onSubmit && onSubmit(bStr, sStr)
    setShow(false)
  }, [ beds, source ])

  const close = useCallback((e: any) => {
    e.stopPropagation()
    setShow(false)
  }, [setShow])

  const open = useCallback((e: any) => {
    e.stopPropagation()
    setShow(true)
  }, [setShow])

  const clear = useCallback((e: any) => {
    e.stopPropagation()
    setBeds(new Set([]))
    setsource(new Set([0]))
  }, [setBeds, setsource])

  const bedsChange = useCallback((flag: boolean, index: number, isBed:boolean) => {
    if (flag) {
      isBed ? beds.add(index) : source.add(index)
    } else {
      isBed ? beds.delete(index) : source.delete(index)
    }
    isBed ? setBeds(beds) : setsource(source)

  }, [beds, source, setsource, setBeds])

  let uniq = new Date().valueOf()

  return (
    <>
      <div
        className={`z-[10] fixed w-[100%] h-[100%] top-0 ${show ? '' : 'hidden'} left-0 bg-mask-bg`}
        id='m2m_option_mask'
        onClick={close}
      />
      <div className=' relative'>
        <div className={`absolute -top-6 right-0 ${show ? '' : 'hidden'}`}>
          <img className=' w-8 h-8' src={require('../../../img/point@3.png')}  alt='point' />
        </div>

        <div
          className=' flex w-[61px] items-center justify-between'
          onClick={open}
        >
          <img className=' w-6 h-6' src={require('../../../img/filter@3.png')}  alt='point' />
          <span className=' text-base text-black font-[500] font-Poppins'>Filter</span>
        </div>

        <div className={` overflow-hidden z-50 absolute max-w-[426px] min-w-[375px] right-0 top-8 bg-white p-4 pb-0 border border-[#EAEDEE] rounded-lg ${show ? '' : 'hidden'}`}>
          <CloseBtn
            className=' right-0 top-0'
            onClose={close}
          />
          <h2>Bedrooms</h2>
          <div className=' flex h-[48px] pt-2'>
            {
              Bads.map((bedTitle, ind) => {
                return (
                  <div className=' mr-5'>
                    <Checked
                      key={`${bedTitle}${uniq}`}
                      label={bedTitle}
                      checked={beds.has(ind)}
                      onChange={(flag) => bedsChange(!!flag, ind, true)}
                    />
                  </div>
                )
              })
            }
          </div>

          <h2>Source</h2>
          <div className=' grid grid-cols-2 grid-flow-row gap-2 mt-2'>
            {
              source_img.map(({ imgurl, tag }, ind) => {
                return (
                  <div className=' flex justify-start'>
                    <Checked
                      key={`${imgurl}${uniq}`}
                      className={`${tag === 1 ? ' -top-[2px] relative' : ''}`}
                      label={<img className=' h-6' alt={imgurl}  src={require(`../../../img/${imgurl}`)} />}
                      disable={!ind}
                      checked={source.has(tag)}
                      onChange={(flag) => bedsChange(!!flag, tag, false)}
                    />
                  </div>
                )
              })
            }
          </div>

          <div className='h-[1px] bg-lines mt-[22px]' />

          <div className=' h-[64px] flex justify-between items-center'>
            <div className=' h-6 cursor-pointer hover:underline' onClick={clear}>Clear</div>
            <div className=' py-2 px-[48px] bg-blue rounded-[6px] cursor-pointer text-white' onClick={submit}>Search</div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Fileter;
